import NavBar from 'components/navbar/NavBar'
import Footer from '../components/footer/Footer'

import Header from 'components/typography/Header'

import styles from './styles/Error.css'
import classNames from '../../node_modules/classnames/index'
import Btn from '../components/forms/styles/Button.css'
import { Link } from '../components/misc/Link'

const errors = {
  404: {
    code: 404,
    title: 'Not Found',
    message: 'Pete sniffed everywhere… no luck.'
  },
  401: {
    code: 401,
    title: 'Unauthorized',
    message: 'Pete needs to see your credentials.'
  },
  403: {
    code: 403,
    title: 'Forbidden',
    message: 'Pete has decided you may not pass.'
  },
  451: {
    code: 451,
    title: 'Unavailable for Legal Reasons'
  }
}

export const Error = ({ status }) => (
  <div>
    <NavBar staticPage />
    <div className={styles.error}>
      <img alt='Stylized Pete' className={styles.errorImage} src={`${CONFIG.assetsBaseURL}/images/pete-stylized.png`} />
      <p className={styles.errorTitle}>
        {errors[status]?.code && `${errors[status].code} | `}
        {errors[status]?.title || 'Error'}
      </p>
      <Header level={2}>{errors[status]?.message || 'Something went wrong!'}</Header>
      <div className={classNames(styles.buttonLayout)}>
        <Link className={classNames(styles.button, Btn['btn--blue'], Btn.btn, Btn['size--medium'])} to='/'>
          Head back home
        </Link>
      </div>
    </div>
    <Footer />
  </div>
)

export default Error
